import { render, staticRenderFns } from "./LeftAside.vue?vue&type=template&id=38549d6e&scoped=true"
import script from "./LeftAside.vue?vue&type=script&lang=ts"
export * from "./LeftAside.vue?vue&type=script&lang=ts"
import style0 from "./LeftAside.vue?vue&type=style&index=0&id=38549d6e&prod&scoped=true&lang=css"
import style1 from "./LeftAside.vue?vue&type=style&index=1&id=38549d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38549d6e",
  null
  
)

export default component.exports